import { getCookie, setCookie } from "../../js/Util";

$('.js-cookie-disclaimer').each(function(i, rootDom) {
    const isShown = getCookie('agree-use-cookie');

    if (!isShown) {
        $(rootDom).addClass('_visible');
    }

    $('.js-cookie-disclaimer-agree', rootDom).on('click', function() {
        setCookie('agree-use-cookie', true, {expires: 365, path: '/' });
        $(rootDom).removeClass('_visible');
    });
});
